<template>
    <div>
        <div class="title-col2 text-center">
            <h2>Publish your helm chart</h2>
            <p class="text-dark mb-4 mt-1">Click “Create chart” button or use 'helm push' to publish your chart</p>
            <p>if you are familiar with helm push plugin then:</p>
        </div>
        <div class="card-style">
            <div class="step-list">
                <ul>
                    <li class="li-with-hint">
                        <span>Step 1 Add repo</span>
                        <p>helm repo add {{ slug }} {{ route('repository.view', {team: slug}) }} --username {{ username }} --password<span class="baseclr"> [password_or_token] </span><span class="link-copy"><i class="feather-copy"></i></span></p>
                        <div class="box-text hint-wrap">
                            <p>For the password you may use your account password, or an API key. Alternatively you can use deploy token instead of username and password.</p>
                        </div>
                    </li>
                    <li>
                        <span>Step 2 Install helm-push plugin</span>
                        <p>helm plugin install https://github.com/chartmuseum/helm-push.git<span class="link-copy"><i class="feather-copy"></i></span></p>
                    </li>
                    <li>
                        <span>Step 3 Push helm chart to repository</span>
                        <p>helm cm-push [/path/to/helm/chart] {{ slug }}<span class="link-copy"><i class="feather-copy"></i></span></p>
                    </li>
                </ul>
            </div>
        </div>
        <div class="text-linebar">
            <span>OR</span>
        </div>
        <div class="btn-list">
            <ul>
                <li>
                    <a :href="route('repository.upload', {team: slug})" class="btn btn-style btn-primary w-172 disabled"><span>Upload package</span></a>
                </li>
                <li>
                    <a href="javascript:void(0)" class="btn btn-style btn-secondary w-172 disabled"><span>Import from Git</span></a>
                </li>
            </ul>
        </div>
        <div class="link-col">
            <a :href="route('repository-settings.members', {team: slug})" class="link-btn"><span>Invite team members</span><span><i class="feather-play-circle"></i></span></a>
        </div>
    </div>
</template>

<script>
    export default {
        name: "PushInstructions",
        props: ['slug', 'username']
    }
</script>

<style scoped>

</style>
